import React from 'react'

const Data2 = () => {
  return (
    <div className='data2 p-3'>
        <h1>Guiding Principles Based On Our Goals, Mission And Core Values</h1>
        <h3>We remain aware of the mission</h3>
        <p>We aim to collaborate, and help students through our programmes to inspire and integrate them, using innovative ways.</p>
        <h3>We care for children and people</h3>
        <p>We believe children are gifts of god and any service to them is service to god. We are committed to providing everyone and opportunity to learn, grow and help others grow.</p>
        <h3>We treat everyone with respect</h3>
        <p>We treat all with respect, dignity and honesty. We show respect by listening to and seeking to understand different points of views, being sensitive to cultural and religious diversity, and by working collaboratively with others to achieve common goals and a harmonious work culture.
We collaborate to build partnerships</p>
        <h3>We collaborate to build partnerships</h3>
        <p>We actively seek to partner with organizations with similar goals, individuals, and corporates to enhance the effectiveness of our programs and advance common interests.</p>
        <h3>We honour the responsibilities entrusted to us</h3>
        <p>We constantly seek opportunities and innovative ways to create value through the work that we do to further our mission.</p>
    </div>
  )
}

export default Data2